import { type PimProductV11 } from '@redteclab/api/clients/bully'

const CONTRACEPTIVE_INDICATION_CODE_29B = '29B'
const CONTRACEPTIVE_INDICATION_CODE_31I = '31I'

export const productAccessorIsContraceptive = (
  product: PimProductV11,
): boolean =>
  Boolean(
    product.indication_ranges?.some(
      (indicationRange) =>
        indicationRange.code === CONTRACEPTIVE_INDICATION_CODE_29B ||
        indicationRange.code === CONTRACEPTIVE_INDICATION_CODE_31I,
    ),
  )
